import loading_animation from 'animations/tqps-loading.gif';

const Loading = props => {
	if (!props.loading) {
		return null;
	}
	const handleContentClick = e => {
		e.stopPropagation();
	};

	return (
		<div className="modal-overlay">
			<img className="loading-animation" src={loading_animation} />
		</div>
	);
};

export default Loading;
